import { Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Popover, TextField, Tooltip } from "@mui/material";
import { ColDef, ColumnApi, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LoadPhoneNumberGroups, LoadPhoneNumbersGridData } from "../../actions";
import Config from "../../config";
import { setHeaderCount, setHeaderTitle, setRefreshHandler, setSelectedCount } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { AddNumberIcon, CancelIcon, CancelSubscriptionIcon, EditIcon, LandlineIcon, MSteamsIcon, NewInfoCircleIcon, PlanDetailsIcon, ReHostIcon, RechargeIcon, TollfreeIcon, TransactionHistoryIcon, ViewDetailsIcon, VoipIcon } from "../../icon";
import { ProductType } from "../../models/add-phone-number.model";
import { mapToOrganizationDetails } from "../../models/organization.model";
import { PhoneNumbergroup, PhoneNumberModel, PhoneNumberStatus } from "../../models/phone-number.model";
import { PhoneNumberPlan, PlanModel, PlanType } from "../../models/plans.model";
import { PlanHistoryModel, RechargeStatus } from "../../models/transaction-history.model";
import * as selector from "../../selectors/selectors";
import { OrganizationService } from "../../services/OrganizationService";
import { PhoneNumberService } from "../../services/PhonenumberService";
import { UserService } from "../../services/UserService";
import { LocalStorage, UtilityService } from "../../services/UtilityService";
import chargebeeService from "../../services/chargebee.service";
import { IPaymentProps } from "../payment/payment.component";
import CurrentPlanDetails from "../phone-numbers/current-plan-details.component";
import { AppRoutes } from "../routes/route.path";
import ButtonComponent from "../shared/button/button.component";
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, GridStatusLabelVariant, PlansHeaders, ProductTypeLabel, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles } from "../shared/constants";
import FilterComponent from "../shared/filters/filter.component";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import { validateForm } from "../shared/form-validation";
import GridComponent from "../shared/grid";
import { ActionsRenderer } from "../shared/grid/actionsRenderer";
import { AddOnRenderer } from "../shared/grid/addOnRenderer";
import { AvatarRenderer } from "../shared/grid/avatarRenderer";
import { HeaderTemplate } from "../shared/grid/grid.services";
import { StatusRenderer } from "../shared/grid/statusRenderer";
import { TypeRenderer } from "../shared/grid/typeRendrer";
import PageHeaderComponent from "../shared/page-header.component";
import PhoneSubscriberDetailsComponent from "../shared/phone-subscriber-details.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import PhoneNumberGroups from "../PhoneNumberGroup";
import { Role } from "../../models/roles.model";


interface RouteID {
    phoneID: string;
}

const Plans = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const location = useLocation();
    const organizationId = UserService.getCurrentUserOrgId();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const phoneNumberGroups: PhoneNumbergroup[] = useSelector(selector.phonenumbergroups);
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow)
    const [currentPlan, setCurrentPlan] = useState<PlanHistoryModel>()
    const [currentAddons, setCurrentAddons] = useState<PlanModel[]>([])
    const [currentPhoneNumber, setCurrentPhoneNumber] = useState<PhoneNumberModel>()
    const [phoneNumberData, setPhoneNumberData] = useState<PhoneNumberModel>()
    const [gridApi, setGridApi] = useState<any>()
    const [showCurrentPlanDetails, setShowCurrentPlanDetails] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [showViewDetails, setShowViewDetails] = useState<boolean>(false)
    const [phoneNumberID, setPhoneNumberID] = useState<string>("")
    const [phoneNumberName, setPhoneNumberName] = useState<string>("")
    const [subscriptionID, setSubscriptionID] = useState<string>("")
    const [showCancelSubscriptionConfirmation, setShowCancelSubscriptionConfirmation] = useState<boolean>()
    const [cancelSubscriptionError, setShowCancelSubscriptionError] = useState<boolean>(false)
    const [filterPopUp, setFilerPopUp] = useState<boolean>(false)
    const [anchorEl, setAnchoeEl] = useState<Element>(null)
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [errors, setErrors] = useState({ Name: "" });
    const [filterOptions, setFilterOptions] = useState<any[]>([]);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [IsManual, setIsManual] = useState<boolean>(false)
    const [showCreateGroup, setShowCreateGroup] = useState<boolean>(false);
    const getPhoneNumber = (id: string) => {
        return UtilityService.maskPhoneNumberOnLength(id);
    }


    let PlansColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Name",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `${params.data.Name}`
                }
            },
            cellRenderer: (params: any) => {
                return (
                    <div className="o-hidden w-space w-p-100 t-overflow-ellipsis">
                        {params.data.Name}
                    </div>
                );
            },
            maxWidth: 300
        },
        {
            field: "Phone Number",
            headerName: "Phone Number",
            valueFormatter: (params) => {
                return UtilityService.maskPhoneNumberOnLength(params.data.PhoneNumber)
            },
            valueGetter: (params: ValueGetterParams) => {
                const raw = UtilityService.maskPhoneNumberOnLength(params.data.PhoneNumber) || "";
                return ` ${raw} ${raw.replace(/\D/g, "")} `;
            },
            suppressSizeToFit: true,
        },
        {
            field: "PhoneNumberGroup",
            headerName: "Line Group",
            valueGetter: (params: ValueGetterParams) => {
                const group = phoneNumberGroups.find(x => x.PhoneNumbers?.some(y => y.phoneNumberId === params.data.ID));
                return group ? group.GroupName : "---";
            },
            suppressSizeToFit: true,
            minWidth: IsMobileDevice ? null : 150,
            width: IsMobileDevice ? null : 150,
            hide: UserService.hasSysAdminRole()
        },
        {
            field: "type",
            headerName: "Type",
            autoHeight: true,
            headerComponentParams: {
                template: selectedFilterTypes.includes("Type") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.ProductType === ProductType.LANDLINE_TEXTING ? ProductTypeLabel.LANDLINE_TEXTING : params.data.ProductType === ProductType.VOIP_TEXTING ? ProductTypeLabel.VOIP_TEXTING : params.data.ProductType === ProductType.MS_TEAMS_TEXTING ? ProductTypeLabel.MS_TEAMS_TEXTING : ProductTypeLabel.TOLL_FREE_TEXTING
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (!!params.data) {
                    const label = params.data.ProductType === ProductType.LANDLINE_TEXTING ? ProductTypeLabel.LANDLINE_TEXTING : params.data.ProductType === ProductType.VOIP_TEXTING ? ProductTypeLabel.VOIP_TEXTING : params.data.ProductType === ProductType.MS_TEAMS_TEXTING ? ProductTypeLabel.MS_TEAMS_TEXTING : ProductTypeLabel.TOLL_FREE_TEXTING;
                    const icon = params.data.ProductType === ProductType.LANDLINE_TEXTING ? LandlineIcon : params.data.ProductType === ProductType.VOIP_TEXTING ? VoipIcon : params.data.ProductType === ProductType.MS_TEAMS_TEXTING ? MSteamsIcon : TollfreeIcon;
                    const Type = {
                        component: TypeRenderer,
                        params: {
                            Icon: icon, Label: label, Id: params.data.ID
                        }
                    }
                    return Type
                }
            },
            hide: IsNewOrgFlow
        },
        {
            field: "users",
            headerName: "Users",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Users
            },
            cellRenderer: (params: ICellRendererParams) => {
                const State = { PhoneNumberID: PhoneNumbers.find(x => x.PhoneNumber === params.data.PhoneNumber)?.ID }
                return <Link to={IsNewOrgFlow ? AppRoutes.NEW_USERS : AppRoutes.USERS} state={State} className="color-vigenary-light">{params.data.Users}</Link>
            },
        },
        {
            field: "Status",
            headerName: "Current Status",
            autoHeight: true,
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Status === PhoneNumberStatus.IN_PROGRESS ? "In progress" : params.data.Status === PhoneNumberStatus.PAYMENT_DUE ? "Payment due" : params.data.Status === PhoneNumberStatus.ACTIVE ? "Active" : "In active"
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (!!params.data) {
                    const label = params.data.Status === PhoneNumberStatus.IN_PROGRESS ? "In progress" : params.data.Status === PhoneNumberStatus.PAYMENT_DUE ? "Payment due" : params.data.Status === PhoneNumberStatus.ACTIVE ? "Active" : "In active";
                    const variant = params.data.Status === PhoneNumberStatus.IN_PROGRESS ? GridStatusLabelVariant.Warning : params.data.Status === PhoneNumberStatus.PAYMENT_DUE ? GridStatusLabelVariant.Danger : params.data.Status === PhoneNumberStatus.ACTIVE ? GridStatusLabelVariant.Active : GridStatusLabelVariant.Inactive;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
            },
        },
        {
            field: "Current Plan",
            headerName: "Current Plan",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data ? `${!!getCurrentPlan(params)?.PlanName ? getCurrentPlan(params)?.PlanName : "---"}` : "---"
            },
            headerComponentParams: {
                template: selectedFilterTypes.includes("Plans") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            cellRenderer: (params: any) => {
                return (
                    <div className="o-hidden w-space w-p-100 t-overflow-ellipsis">
                        {!!params.data ? `${!!getCurrentPlan(params)?.PlanName ? getCurrentPlan(params)?.PlanName : "---"}` : "---"}
                    </div>
                );
            },
            hide: IsNewOrgFlow
        },
        {
            field: "Plan Validity",
            headerName: "Plan Validity",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data ? `${!!getCurrentPlan(params)?.EndDate ? UtilityService.convertDateToDay(getCurrentPlan(params)?.EndDate) : "---"}` : "---"
            },
            cellStyle: { textOverflow: 'ellipsis', display: "flex", justify: "space-center", alignItems: "center" },
            sort: "desc",
            hide: IsNewOrgFlow,
        },
        {
            field: "AddOn",
            headerName: "AddOns",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return getAddons(params.data)
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (!!params.data) {
                    const icon = params.data.ProductType === ProductType.LANDLINE_TEXTING ? LandlineIcon : params.data.ProductType === ProductType.VOIP_TEXTING ? VoipIcon : params.data.ProductType === ProductType.MS_TEAMS_TEXTING ? MSteamsIcon : TollfreeIcon;
                    const data = getAddons(params.data)
                    const Addons = {
                        component: AddOnRenderer,
                        params: {
                            Data: data, Number: params.data, Icon: icon
                        }
                    }
                    return Addons
                }
            },
            hide: IsNewOrgFlow
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer MenuData={[{
                Name: ActionLabels.CURRENT_PLAN_DETAILS,
                Icon: PlanDetailsIcon,
                Hide: IsNewOrgFlow ? true : params.data.Status !== PhoneNumberStatus.ACTIVE,
                OnClick: () => {
                    getCurrentAddons(params.data)
                    setShowCurrentPlanDetails(true)
                    setCurrentPhoneNumber(params.data)
                    setCurrentPlan(getCurrentPlan(params))
                    // setCurrentAddons([getCurrentPlan(params).Plan])
                }
            },
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => ShowIsEdit(params)
            },
            {
                Name: ActionLabels.REHOST,
                Icon: ReHostIcon,
                Hide: params.data.Status !== PhoneNumberStatus.INACTIVE,
                OnClick: () => rehost(params.data)
            },
            {
                Name: ActionLabels.RECHARGE,
                Icon: RechargeIcon,
                Hide: IsNewOrgFlow ? true : params.data.Status === PhoneNumberStatus.INACTIVE || IsTeamsApp || IsManual === true,
                OnClick: () => recharge(params.data)
            },
            {
                Name: ActionLabels.CANCEL_SUBSCRIPTION,
                Icon: CancelSubscriptionIcon,
                Hide: IsNewOrgFlow ? true : params.data.Status === PhoneNumberStatus.ACTIVE ? params.data.Plans.length > 0 && params.data.Plans.find(x => x.PlanType === PlanType.TIER && x.StatusType === RechargeStatus.ONGOING)?.IsItemCancelled : true,
                OnClick: () => ShowCancelSubscription(params.data)
            },
            {
                Name: ActionLabels.PLANS_HISTORY,
                Icon: TransactionHistoryIcon,
                OnClick: () => goToPlanHistory(params.data.ID),
                Hide: IsNewOrgFlow ? true : false
            },
            {
                Name: ActionLabels.VIEW_DETAILS,
                Icon: ViewDetailsIcon,
                OnClick: () => ViewDetails(params)
            },
            ]}
                {...params}
            />,
            resizable: false,
            sortable: false,
        },
    ]

    const initialFilterOptions = () => {
        const filterData: any[] = [
            {
                Id: 1,
                Title: "Type",
                IsSelectedAll: false,
                Options: _(PhoneNumbers)
                    .map(row => ({
                        Key: "ProductType",
                        Id: row.ID,
                        Label: row.ProductType === ProductType.LANDLINE_TEXTING ? ProductTypeLabel.LANDLINE_TEXTING : row.ProductType === ProductType.VOIP_TEXTING ? ProductTypeLabel.VOIP_TEXTING : row.ProductType === ProductType.MS_TEAMS_TEXTING ? ProductTypeLabel.MS_TEAMS_TEXTING : ProductTypeLabel.TOLL_FREE_TEXTING,
                        Value: row.ProductType,
                        IsSelected: false,
                    }))
                    .uniqBy('Label')
                    .value()
            },
            {
                Id: 2,
                Title: "Status",
                IsSelectedAll: false,
                Options: _(PhoneNumbers)
                    .map(row => ({
                        Key: "Status",
                        Id: row.ID,
                        Label: row.Status === PhoneNumberStatus.IN_PROGRESS ? "In progress" : row.Status === PhoneNumberStatus.PAYMENT_DUE ? "Payment due" : row.Status === PhoneNumberStatus.ACTIVE ? "Active" : "Inactive",
                        Value: row.Status,
                        IsSelected: false
                    }))
                    .uniqBy('Label')
                    .value()
            },
            {
                Id: 3,
                Title: "Plans",
                IsSelectedAll: false,
                Options: _(PhoneNumbers)
                    .map(row => {
                        const currentPlan = row.CurrentPlan;
                        if (currentPlan !== undefined && currentPlan !== null) {
                            return {
                                Key: "CurrentPlan",
                                Id: row.ID,
                                Label: currentPlan,
                                Value: currentPlan,
                                IsSelected: false
                            };
                        }
                        return null;
                    })
                    .compact()
                    .uniqBy('Label')
                    .value()
            }
        ]
        setFilterOptions(filterData)
    }

    const handleApplyFilters = (filters: CustomFilterCategory[]) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    useEffect(() => {
        initialFilterOptions()
    }, [PhoneNumbers])

    useEffect(() => {
        LoadPhoneNumberGroups(dispatch, organizationId)
    }, [])

    const resetFilters = () => {
        setFilterOptions([])
        setSelectedFilterTypes([])
        initialFilterOptions()
    }

    useEffect(() => {
        setHeaderTitle(IsNewOrgFlow ? pageTitles.PLANS : pageTitles.PLANS);
        setHeaderCount(UserService.hasManagerRole() ? phonedata()?.length : PhoneNumbers?.length || 0)
        setRefreshHandler(refreshData);
        return setHeaderTitle
    }, [gridApi, columnApi])

    useEffect(() => {
        setHeaderCount(UserService.hasManagerRole() ? phonedata()?.length : PhoneNumbers?.length || 0)
        setSelectedCount(0)
    }, [PhoneNumbers])

    // useEffect(() => {
    //     SettingsService.getManualsubscription(UserService.getCurrentUserOrgId(), "MS")
    //         .then(setting =>
    //             setIsManual(setting.data.value.toLowerCase() === "true"))
    // }, [])

    const removeDuplicates = (array) => {
        return array.filter((a, b) => array.indexOf(a) === b)
    }

    const getCurrentPlan = (params) => {
        if (!!params.data) {
            const Plans = params.data.Plans
            const currentPlan = Plans.filter(x => x.PlanType === PlanType.TIER && x.StatusType === RechargeStatus.ONGOING)[0]
            return !!currentPlan ? currentPlan : " "
        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const onSearch = (e: any) => {
        gridApi.setQuickFilter(e.target.value)
    }

    const refreshData = () => {
        resetFilters()
        LoadPhoneNumbersGridData(dispatch);
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    const addPhoneNumber = () => {
        navigate(IsNewOrgFlow ? AppRoutes.NEW_ADD_PHONE_NUMBER : AppRoutes.ADD_PHONE_NUMBER);
    }

    const rehost = (phoneData?: PhoneNumberPlan) => {
        if (!phoneData) {
            return;
        }
        navigate(AppRoutes.REHOST, { state: { ...phoneData }, replace: true })
    }

    const goToPlanHistory = (id: string) => {
        navigate({
            pathname: AppRoutes.PLANS_PLAN_HISTORY.replace(':phoneID', id),
        })
    }

    const closeCurrentPlanDetails = () => {
        setShowCurrentPlanDetails(false)
    }

    const getCurrentAddons = (data) => {
        const AddOns = data.Plans.filter((item: PlanHistoryModel) => item.PlanType === PlanType.ADD_ON && item.StatusType === RechargeStatus.ONGOING);
        const addoninfo = removeDuplicates(AddOns.map(x => x.PlanID))
        const currentAddons = addoninfo.map(x => data.Plans.find(y => y.PlanID === x)).map(x => x.Plan)
        setCurrentAddons(currentAddons)
    }

    const getAddons = (data: PhoneNumberModel) => {
        const AddOns = data.Plans.filter((item: PlanHistoryModel) => item.PlanType === PlanType.ADD_ON && item.StatusType === RechargeStatus.ONGOING);
        const addoninfo = removeDuplicates(AddOns.map(x => x.PlanID))
        const currentAddons = addoninfo.map(x => data.Plans.find(y => y.PlanID === x)).map(x => x.Plan)
        return currentAddons
    }

    const HandlePage = () => {
        setIsEdit(false)
        setErrors({ Name: "" })
    }

    const ShowIsEdit = (params) => {
        setIsEdit(true)
        setPhoneNumberData(params.data)
        setPhoneNumberName(params.data.Name)

    }

    const handleEditchange = (name: string, value: string) => {

        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors });
            })
        setPhoneNumberName(value)
    }

    const closeViewDeatils = () => {
        setShowViewDetails(false)
    }

    const ViewDetails = (params) => {
        setShowViewDetails(true)
        setPhoneNumberID(params.data.ID)
        setPhoneNumberName(params.data.Name)
    }

    const getGridTitle = () => {

        if (PhoneNumbers.length === 1) {
            return "1 Plan"
        }
        else {
            return PhoneNumbers.length + " " + pageTitles.PLANS
        }
    }

    const recharge = (phoneData) => {
        if (!phoneData) {
            return;
        }
        OrganizationService.getOrganizationById(UserService.getCurrentUserOrgId()).then(res => {
            let org = mapToOrganizationDetails(res.data);
            let data = {
                PhoneNumberID: phoneData?.ID,
                PhoneNumberToRecharge: phoneData?.PhoneNumber,
                ProductType: phoneData?.ProductType,
                Organization: org,
                IsRecharge: true,
                IsAddonRecharge: phoneData?.Status === PhoneNumberStatus.ACTIVE,
                ...org,
                PhonePlans: phoneData?.Plans,
                CurrentPlanID: phoneData?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.PlanID,
                SubscriptionID: phoneData?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.SubscriptionID
            } as unknown as IPaymentProps;

            navigate(AppRoutes.RECHARGE, { state: { ...data }, replace: true })

        }).catch(error => {
        })
    }

    const EditPhoneNumber = (event: any) => {
        setIsLoading(true)
        event.preventDefault();
        const data = {
            id: phoneNumberData.ID,
            name: phoneNumberName,
            number: phoneNumberData.PhoneNumber,
            provider: phoneNumberData.Provider,
            organizationId: phoneNumberData.OrganizationID
        }
        PhoneNumberService.updatePhoneNumber(data).then(res => {
            HandlePage();
            setToast(ToasterTexts.PHONE_NUMBER_NAME_EDIT_SUCCESS.replace('<Name>', data.name), ToasterType.SUCCESS)
            refreshData();
            setIsLoading(false)
            setErrors({ Name: "" })
        })
    }

    const ShowCancelSubscription = (phoneData) => {
        let Id = phoneData?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.SubscriptionID
        setSubscriptionID(Id)
        setShowCancelSubscriptionConfirmation(true)
    }

    const cancelSubscription = () => {
        closeCancelSubscriptionConfirmation();
        setToast(ToasterTexts.CANCELLING_SUBSCRIPTION, ToasterType.INFO)

        chargebeeService.cancelSubscription([subscriptionID]).then(res => {
            if (res.status === 200) {
                setShowCancelSubscriptionError(false)
                setToast(ToasterTexts.CANCEL_SUBSCRIPTION_SUCCESS, ToasterType.SUCCESS)
                LoadPhoneNumbersGridData(dispatch);

            }
        }).catch(error => {
            if (error.response.status === 500) {
                setShowCancelSubscriptionError(true)
            }
            else {
                setToast(ToasterTexts.CANCEL_SUBSCRIPTION_FAILED, ToasterType.DANGER)
                setShowCancelSubscriptionError(false)
            }
        })
        refreshData()
    }

    const closeCancelSubscriptionConfirmation = () => {
        setShowCancelSubscriptionConfirmation(false)
        setSubscriptionID("")
    }

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        setFilerPopUp(!filterPopUp)
        setAnchoeEl(event.currentTarget)
    }

    const handleCloseFilter = () => {
        setFilerPopUp(false)
        setAnchoeEl(null)
    }

    const handleCreateGroup = () => {
        setShowCreateGroup(true)
    }

    const phonedata = (): any => {
        const user = LocalStorage.get("current-user");
        const ids = [user?.phoneNumberId, ...(user?.secondaryPhoneNumbers?.map((x: any) => x.phoneNumberId) || [])];
        return PhoneNumbers.filter(x => ids.includes(x.ID));
    }
    const handleCellRowClick = (e: any, row: any) => {
        if (!IsMobileDevice && e.colDef.field !== "Action") {
            const data = getCurrentPlan(e)
            if (!!data && typeof data === "object") {
                setShowCurrentPlanDetails(true)
                setCurrentPlan(getCurrentPlan(e))
                getCurrentAddons(e.data)
                setCurrentPhoneNumber(e.data)
            }
        }
    }

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            <PageHeaderComponent
                GridTitle={""}
                Count={PhoneNumbers.length}
                Actions={location.pathname.replace("/*", "") === AppRoutes.PLANS
                    ? [!UserService.hasManagerRole() && {
                        OnClick: () => addPhoneNumber(),
                        ButtonLabel: buttonLabels.ADD_PHONENUMBER,
                        Icon: AddNumberIcon,
                        Variant: "primary-btn",

                    }]
                    : [UserService.hasOrgAdminRole() && {
                        OnClick: () => handleCreateGroup(),
                        ButtonLabel: buttonLabels.CREATE_LINE_GROUP,
                        Icon: AddNumberIcon,
                        Variant: "primary-btn",
                    }]
                }
                HandleFilter={handleClickFilter}
                ShowFilterIcon={(IsNewOrgFlow || location.pathname.replace("/*", "") !== AppRoutes.PLANS) ? false : true}
                IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                onSearch={onSearch}
                PlaceHolder={"Search ..."}
            />
            {location.pathname.replace("/*", "") === AppRoutes.PHONENUMBER_GROUPS && <div className="report-text color-conv-section-inactive  px-3">
                <div>Organize your phone lines into groups by department, location, team, or any structure that fits your business, so the right people always work from the right lines.</div>
            </div>
            }
            {(UserService.hasOrgAdminRole() || UserService.hasManagerRole()) &&
                <div className="d-flex justify-between w-p-100 px-2">
                    <div>
                        <div className='d-flex'>
                            <Link className={`${location.pathname.replace("/*", "") === AppRoutes.PLANS ? 'ml-1 w-16 t-align-center py-1 c-pointer color-conv-hist-menu  h4-semibold' : 'ml-1 w-16 t-align-center py-1 c-pointer color-conv-section-inactive h4-semibold'}`} to={AppRoutes.PLANS}>
                                {"Phone Lines"}
                            </Link>
                            <Link className={`${location.pathname.replace("/*", "") === AppRoutes.PHONENUMBER_GROUPS ? 'w-20 t-align-center py-1 c-pointer color-conv-hist-menu  h4-semibold' : 'w-20 t-align-center py-1 c-pointer color-conv-section-inactive h4-semibold'}`} to={AppRoutes.PHONENUMBER_GROUPS}>
                                {"Line Groups"}
                            </Link>
                        </div>
                        <div className={`show-conversation-animation show-conversation-border show-conversation-height bg-color-primary-light ${location.pathname.replace("/*", "") === AppRoutes.PLANS ? "ml-1 w-16" : "ml-17 w-20"}`} />
                    </div>
                </div>
            }
            {location.pathname.replace("/*", "") === AppRoutes.PLANS ?
                <div className="h-p-100">
                    <GridComponent
                        ColumnDefs={PlansColoumnDefs}
                        RowData={UserService.getLoggedInUserRole() === Role.MANAGER ? phonedata() : PhoneNumbers}
                        OnGridReady={onGridReady}
                        IsPaginationEnabled={true}
                        EmptyLabel={emptyLabels.PLANS}
                        LockVisible={IsMobileDevice}
                        OnGridRowClick={() => { }}
                        filterOptions={filterOptions}
                        IsFilterPresent={true}
                        gridApi={gridApi}
                        OnGridCellRowClick={handleCellRowClick}
                        ShowRowPointer={true}
                    />
                </div>
                :
                <div className="h-p-100">
                    <PhoneNumberGroups
                        show={showCreateGroup}
                        setShow={() => setShowCreateGroup(false)}
                        GridApi={gridApi}
                        OnGridReady={onGridReady}
                    />
                </div>
            }

            {
                showCurrentPlanDetails &&
                <CurrentPlanDetails CurrentAddons={currentAddons}
                    Open={showCurrentPlanDetails} HandleClose={closeCurrentPlanDetails} CurrentPlan={currentPlan} CurrentPhoneNumber={currentPhoneNumber} IsMobileDevice={false} />
            }

            {showViewDetails && (<PhoneSubscriberDetailsComponent CloseViewDeatils={closeViewDeatils} ViewDetails={showViewDetails} IsMobileDevice={false} PhoneNumberID={phoneNumberID} PhoneNumberName={phoneNumberName} IsDarkMode={IsDarkMode} />)
            }

            {
                isEdit &&
                <Dialog maxWidth="sm" fullWidth={true} open={isEdit} onClose={HandlePage} aria-labelledby="customized-dialog-title" aria-describedby="alert-dialog-description"
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    classes={{ paper: `w-66 br-2 ${IsDarkMode ? "bg-color-sidebar-bg" : "dialogue-shadow"}` }}
                    disableEscapeKeyDown
                >
                    <form action="" noValidate autoComplete="off" onSubmit={EditPhoneNumber}>
                        <DialogTitle className="dialog-h1">
                            <div className={`${IsMobileDevice ? 'h1 color-display-title' : 'h2-regular color-send-msg-title'} d-flex`} id="customized-dialog-title">
                                {PlansHeaders.EDIT}
                                <Tooltip title='Close' placement='bottom'>
                                    <span className="ml-auto">
                                        <CancelIcon className={"c-pointer"} onClick={HandlePage} />
                                    </span>
                                </Tooltip>
                            </div>
                        </DialogTitle>
                        <DialogContent className="p-2">
                            <div className="mt-1">
                                <TextField label="Name" name="Name" required fullWidth value={phoneNumberName} onChange={(e: any) => handleEditchange(e.target.name, e.target.value)}
                                    variant="outlined" InputProps={{ classes: { input: `${IsMobileDevice ? 'h2' : 'h4-regular'} color-text-field-font` } }}
                                    size='small'
                                />
                                <FormHelperText className={`${IsMobileDevice ? 'h5' : 'h6-regular'} color-primary-danger t-align-right`}>
                                    {errors.Name}
                                </FormHelperText>
                            </div>
                        </DialogContent>
                        <DialogActions className='mt-1 pb-2 pr-2'>
                            <ButtonComponent Variant="secondary-btn-small" OnClick={HandlePage}
                                ClassName={`d-flex ${IsMobileDevice && 'float-right'} mr-1 ml-auto`}
                                ButtonLabel={buttonLabels.CANCEL} />
                            <ButtonComponent Variant={!!errors.Name ? "disabled-btn-small" : "primary-btn-small"} Type="submit" Loading={IsLoading}
                                ClassName={`d-flex ${IsMobileDevice && 'float-right'} px-4`}
                                ButtonLabel={buttonLabels.SAVE} />
                        </DialogActions>
                    </form>
                </Dialog>
            }
            {
                showCancelSubscriptionConfirmation &&
                <ConfirmDialog
                    onClose={(flag) => {
                        if (flag) {
                            cancelSubscription();
                        }
                        else {
                            closeCancelSubscriptionConfirmation();
                        }
                    }}
                    Title={PlansHeaders.CONFIRM}
                    Show={showCancelSubscriptionConfirmation}
                    Text={appNote.CANCEL_SUBSCRIPTION_CONFIRMATION}
                    ButtonName={buttonLabels.OKAY}
                    IsMobileDevice={IsMobileDevice} />
            }
            {
                cancelSubscriptionError && <ConfirmDialog
                    onClose={() => setShowCancelSubscriptionError(false)}
                    Show={cancelSubscriptionError}
                    TextProps={() => <p>{ToasterTexts.UNABLE_CANCEL_SUBSCRIPTION} (<a href={`mailto: ${Config.SUPPORT_EMAIL}`} className={`color-primary-light`}>{Config.SUPPORT_EMAIL}</a>) to cancel this Add-on subscription.</p>}
                    ButtonName={buttonLabels.OKAY}
                    HideCancel={true}
                    IsMobileDevice={IsMobileDevice}
                />
            }
            {filterPopUp &&
                <Popover
                    open={!!anchorEl}
                    anchorEl={anchorEl}
                    onClose={handleCloseFilter}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                // classes={{ paper: `min-w-40 ${filterPopUp ? "min-h-40" : ""}` }}
                // BackdropProps={{
                //     invisible: true,
                //     onClick: (event) => event.stopPropagation(),
                // }}
                >
                    <FilterComponent
                        Filters={filterOptions}
                        OnClose={handleCloseFilter}
                        HandleApplyFilters={handleApplyFilters}
                    />
                </Popover>
            }

        </div>
    )
}
export default Plans;